module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAYAAAHOTD43AAAABGdBTUEAALGPC/xhBQAAAOVJREFUKBVjYGBg4AJiENCCUAwMX2EM7PR/qDCMZkhDUmcCYgsA8WIg3gTEEkAMBowwBoiWA2KQ/lYQBwnkA9kgcRckMQZ2qOBvKM2ELLkUmYPGPgHj3wIy4M6FCQLpv0D8AYnPcAzIASlkAWJuKPsMkMYA64AiIIUgPBFDFklgEpDth8SHM7cAWTATSuGi+Bn+QGlQ7ID0vQZiQSAGA3EgeRGIYQZOAbJRAhzIBwUbyDUwNQ+BbG0gxgpAnt8NxDDFG4BsBSAGBQZMbCOQDVJHFGAGqloIxDDNoKAHxTZFAJSMCAIA9voxSkbxYNQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/arrow_down_black_transparent_thick2px_9_5.png
// module id = ./src/_asset/sources/assets/images/arrow_down_black_transparent_thick2px_9_5.png
// module chunks = main